import React from 'react';
import './TodosLoading.css';

function TodosLoading() {
  return (
    <div className="loading-spinner"></div>
  );
}

export { TodosLoading };
